import Icon from "../Icon";

import * as styledElements from "./CheckboxStyles";
import { ReactNode } from "react";

const Checkbox = ({
  id,
  checked,
  onChange,
  styleProps,
  disabled = false,
  indeterminate = false,
  iconDimension,
  label,
}: {
  id?: string;
  checked: boolean;
  onChange?: () => void;
  styleProps?: object;
  disabled?: boolean;
  indeterminate?: boolean;
  iconDimension?: number;
  label?: ReactNode;
}) => {
  const checkboxElement = (
    <styledElements.Checkbox
      checked={checked}
      id={id}
      onClick={label ? undefined : () => !disabled && onChange && onChange()}
      style={styleProps}
      disabled={disabled}
    >
      {checked && !indeterminate && (
        <Icon
          src="/icons/check.svg"
          alt="checked"
          iconDimension={iconDimension || 16}
        />
      )}
      {indeterminate && <Icon src="/icons/remove.svg" alt="indeterminate" />}
    </styledElements.Checkbox>
  );

  if (label) {
    return (
      <styledElements.Container
        disabled={disabled}
        onClick={() => !disabled && onChange && onChange()}
      >
        {checkboxElement}
        <span>{label}</span>
      </styledElements.Container>
    );
  }
  return checkboxElement;
};

export default Checkbox;
